import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor, i18n, showMessage } from "./common";
import { setRateLimitHandler } from "./common/api/apollo/rateLimitErrorLink";
import MainRouter from "./pages/_router/main.router";

// Wired here rather than inside the Apollo link, which cannot reach the store
// without closing an import cycle (the Redux slices import from the apollo barrel).
setRateLimitHandler(() => {
  store.dispatch(showMessage({
    message: i18n.t('common.rateLimited'),
    type: 'error',
    duration: 8000,
  }));
});

const viewportClampStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  overflowX: 'hidden',
  boxSizing: 'border-box',
};

const App = () =>
  <div style={viewportClampStyle}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MainRouter />
      </PersistGate>
    </Provider>
  </div>

export default App;